import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "50",
  height: "47.5",
  viewBox: "0 0 50 47.5",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25-.05L18 16.5 0 18.05l13.65 11.8-4.1 17.6L25 38.1l15.45 9.35-4.1-17.6L50 18.05 32.05 16.5z"
  })]
});